import { toast as toastWeb } from "@/components/ui/toast/use-toast.web";

import type { ToastType } from "./type";

export function showToast({ type, title }: { type: ToastType; title: string }) {
  toastWeb({
    variant: type,
    title: title,
  });
}
